/**
 * @generated SignedSource<<8f753a720c9c157175fe418b7cb4bafb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StoreTier = "basic" | "free" | "light" | "premium" | "standard" | "unlimited";
export type OrgCompactStoresQuery$variables = Record<PropertyKey, never>;
export type OrgCompactStoresQuery$data = {
  readonly me: {
    readonly " $fragmentSpreads": FragmentRefs<"OrgLogoutButton_me">;
  } | null;
  readonly organisation: {
    readonly name: string;
    readonly rootWorkspace: {
      readonly stores: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
        readonly tier: StoreTier;
        readonly timezone: string;
        readonly workspaceBreadcrumbs: ReadonlyArray<string>;
        readonly " $fragmentSpreads": FragmentRefs<"OrgStoreWorkspaceBreadcrumbs_store">;
      }>;
    };
  } | null;
};
export type OrgCompactStoresQuery = {
  response: OrgCompactStoresQuery$data;
  variables: OrgCompactStoresQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tier",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timezone",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "includeExternalId",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "workspaceBreadcrumbs",
  "storageKey": "workspaceBreadcrumbs(includeExternalId:true)"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgCompactStoresQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "OrgLogoutButton_me"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Organisation",
        "kind": "LinkedField",
        "name": "organisation",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "rootWorkspace",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Store",
                "kind": "LinkedField",
                "name": "stores",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v0/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "OrgStoreWorkspaceBreadcrumbs_store"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "OrgCompactStoresQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Organisation",
        "kind": "LinkedField",
        "name": "organisation",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "rootWorkspace",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Store",
                "kind": "LinkedField",
                "name": "stores",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v0/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5a280edf279c0b8bc972a6b810a81069",
    "id": null,
    "metadata": {},
    "name": "OrgCompactStoresQuery",
    "operationKind": "query",
    "text": "query OrgCompactStoresQuery {\n  me {\n    ...OrgLogoutButton_me\n    id\n  }\n  organisation {\n    name\n    rootWorkspace {\n      stores {\n        id\n        name\n        tier\n        timezone\n        workspaceBreadcrumbs(includeExternalId: true)\n        ...OrgStoreWorkspaceBreadcrumbs_store\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment OrgLogoutButton_me on User {\n  name\n  email\n}\n\nfragment OrgStoreWorkspaceBreadcrumbs_store on Store {\n  workspaceBreadcrumbs(includeExternalId: true)\n}\n"
  }
};
})();

(node as any).hash = "502e250e7e4c5db6e40f1499a1572c40";

export default node;
